import { Grid, Typography } from '@material-ui/core';
import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import StepInput from './StepInput';
import { useLang } from '../../../../util/lang';

// type archToTreat = 'both' | 'archToTreatUpper' | 'archToTreatLower'

export const PatientCurrentStepInput = ({
    archToTreat = undefined,
    value = { archToTreatUpperStep: undefined, archToTreatLowerStep: undefined },
    mode,
}) => {
    const dispatch = useDispatch();
    const get = useLang();

    const handleChange = (field, inputValue) => {
        let numberValue = parseInt(inputValue);
        dispatch({ type: 'NEW_PATIENT_PRES_ARCH_PAT_STEP', field, value: !isNaN(numberValue) ? numberValue : '' });
    };

    const renderOption = {
        upper: archToTreat === 'both' || archToTreat === 'archToTreatUpper',
        lower: archToTreat === 'both' || archToTreat === 'archToTreatLower',
    };

    const errors = useMemo(() => {
        return {
            archToTreatUpperStep:
                value.archToTreatUpperStep === undefined ||
                value.archToTreatUpperStep < 0 ||
                value.archToTreatUpperStep === '',
            archToTreatLowerStep:
                value.archToTreatLowerStep === undefined ||
                value.archToTreatLowerStep < 0 ||
                value.archToTreatLowerStep === '',
        };
    }, [value]);

    const disabledInput = mode === 'view';

    return (
        <Grid style={{ marginLeft: 40 }}>
            <Typography style={{ marginBottom: 10 }}>{get('@PatientInfo.modals.question.retrack.1.text')}</Typography>
            {renderOption.upper && (
                <div style={{ marginBottom: 18 }}>
                    <StepInput
                        disabled={disabledInput}
                        value={value.archToTreatUpperStep}
                        label={get('@NewPatient.prescriptionNotes.upper')}
                        onChange={handleChange}
                        error={errors.archToTreatUpperStep}
                        field={'archToTreatUpperStep'}
                    />
                </div>
            )}

            {renderOption.lower && (
                <div>
                    <StepInput
                        disabled={disabledInput}
                        value={value.archToTreatLowerStep}
                        label={get('@NewPatient.prescriptionNotes.lower')}
                        onChange={handleChange}
                        error={errors.archToTreatLowerStep}
                        field={'archToTreatLowerStep'}
                    />
                </div>
            )}
        </Grid>
    );
};

export default PatientCurrentStepInput;
